export default __webpack_public_path__ + "static/solocast-casestudy-4cdfb1a14877b012c5d2f4c3ef050f9c.jpg";